/* eslint-disable no-shadow */
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/consultants`;

const state = {
  consultants: [],
  consultant: null,
  propertyConsultant: null,
  pending: false,
  updating: false,
};

const getters = {
  pending: (state) => state.pending,
  updating: (state) => state.updating,
  consultants: (state) => state.consultants,
  consultant: (state) => state.consultant ?? null,
  propertyConsultant: (state) => state.propertyConsultant ?? null,
};

const mutations = {
  clearErrors() {
    state.pending = false;
    state.updating = false;
  },
  beforeLoading(state) {
    state.pending = true;
  },
  afterLoading(state) {
    state.pending = false;
  },
  beforeChangeRequest(state) {
    state.updating = true;
  },
  afterChangeRequest(state) {
    state.updating = false;
  },
  data(state, data) {
    state.pending = false;
    state.consultant = data;
  },
  consultants(state, data) {
    state.pending = false;
    state.updating = false;
    state.consultants = data;
  },
  propertyConsultant(state, data) {
    state.propertyConsultant = data;
    state.pending = false;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  throw err;
}

const actions = {
  async getPropertyConsultant({ commit }) {
    commit('beforeLoading');
    try {
      const { data } = await ApiService.get(`${endpoint}/current`);
      commit('propertyConsultant', data?.data);
    } catch (error) {
      commit('afterLoading');
      throw handleApiError(commit, error);
    }
  },
  async getConsultants({ commit }) {
    commit('beforeLoading');
    try {
      const { data } = await ApiService.get(`${endpoint}`);
      commit('consultants', data);
    } catch (error) {
      commit('afterLoading');
      throw handleApiError(commit, error);
    }
  },
  async createConsultant({ commit }, payload = {}) {
    commit('beforeChangeRequest');
    try {
      await ApiService.post(`${endpoint}`, payload);
    } catch (error) {
      commit('afterChangeRequest');
      throw handleApiError(commit, error);
    }
  },
  async updateConsultant({ commit }, payload = {}) {
    commit('beforeChangeRequest');
    try {
      await ApiService.put(`${endpoint}`, payload);
    } catch (error) {
      commit('afterChangeRequest');
      throw handleApiError(commit, error);
    }
  },
  async cancelConsultant({ commit }, consultantId) {
    commit('beforeChangeRequest');
    try {
      await ApiService.delete(`${endpoint}/${consultantId}`);
    } catch (error) {
      commit('afterChangeRequest');
      throw handleApiError(commit, error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
